/**
 * Contexte webpack volontairement vide, à passer à `startStimulusApp()`.
 *
 * Le pont sait démarrer l'application sans contexte — il ne charge des définitions que
 * `if (context)` — mais sa signature TypeScript en exige un. Un contexte dont le filtre ne peut
 * correspondre à aucun nom de fichier (`/^$/`) satisfait le type sans rien embarquer : l'application
 * démarre avec les seuls paquets UX déclarés dans `assets/controllers.json`, et les contrôleurs
 * maison sont enregistrés nommément par l'entrée (cf. `public.ts` / `account.ts`).
 */
const emptyContext = require.context('./', false, /^$/);

export default emptyContext;
